import { runAsyncUntilComplete } from 'utils/functional/function/runAsyncUntilComplete';
import { getJson } from 'utils/http/getJson';

import type { BackgroundTask } from './asyncBackendTaskTypes';

type WaitTaskCompletedOptions<TResult, TStep extends string> = {
  onTick?: (task: BackgroundTask<TResult, TStep>) => void;
  onTimeout?: () => void;
  timeoutMs?: number;
};

export function waitTaskCompleted<TResult, TStep extends string = ''>(
  backgroundTask: BackgroundTask<TResult, TStep>,
  options: WaitTaskCompletedOptions<TResult, TStep> = {},
): Promise<TResult> {
  return runAsyncUntilComplete<TResult>({
    fn: async () => {
      const { task } = await getJson<{
        task: BackgroundTask<TResult, TStep>;
      }>(backgroundTask.url);

      options.onTick?.(task);

      if (task.status !== 'COMPLETED') return { type: 'not-completed' };
      return { type: 'completed', data: task.result };
    },
    intervalMs: 500,
    timeoutMs: options.timeoutMs,
  });
}
